import { CarrierType, SealsDto } from '@planning/app/api'
import { RailTallyViewStore } from '@planning/pages/TallymanV2/Stores/RailTallyViewStore'
import { action, makeObservable, observable } from 'mobx'
import { IRailVisitItem } from '../railVisit/RailVisitItem'
import { IEntityStore } from '../types'
import { IVesselVisitItem } from '../vesselVisit/VesselVisitItem'
import { VesselTallyViewStore } from './VesselTallyViewStore'

interface GangResponseDto {
  id: number
  name: string
  description?: string
}

export class TallymanV2ViewStore {
  selectedCarrierType: CarrierType = CarrierType.Vessel
  selectedGang?: GangResponseDto
  lastSubmittedSeals: SealsDto[] = []

  vesselTallyStore: VesselTallyViewStore
  railTallyStore: RailTallyViewStore

  constructor(
    railVisitItemStore: IEntityStore<IRailVisitItem>,
    vesselVisitItemStore: IEntityStore<IVesselVisitItem>,
  ) {
    makeObservable(this, {
      selectedCarrierType: observable,
      selectedGang: observable,
      lastSubmittedSeals: observable,
      setSubmittedSeals: action,
      setSelectedGang: action,
      selectCarrierType: action,
      preselectTrainType: action,
    })
    this.railTallyStore = new RailTallyViewStore(this, railVisitItemStore)
    this.vesselTallyStore = new VesselTallyViewStore(vesselVisitItemStore)
  }

  preselectTrainType(skipRailTally: boolean, skipVesselTally: boolean) {
    if (!skipRailTally && skipVesselTally) {
      this.selectedCarrierType = CarrierType.Train
    }
  }

  selectCarrierType = (carrierType: CarrierType) => {
    this.selectedCarrierType = carrierType
  }

  setSelectedGang = (gang?: GangResponseDto) => {
    this.selectedGang = gang
  }

  setSubmittedSeals = (seals: SealsDto[], hasSeals?: boolean) => {
    this.lastSubmittedSeals = hasSeals
      ? seals.map(seal => ({
          type: seal.type,
          isMissingSeal: seal.isMissingSeal,
          isNewSeal: seal.isNewSeal,
          number: '',
        }))
      : []
  }
}
